import React,{useState, useEffect, useCallback} from 'react';
import axios from 'axios';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';
import { databaseNoport } from '../../server/server.js';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import axiosInstance from '../../server/axios.js';
import LotSelectMaterial from './lotselectmaterial.js';
//react-window
import {FixedSizeList} from "react-window";


const LotMaterial = () => {
    const location = useLocation();
    const [materialList, setMaterialList] = useState([]);
    const [viewList, setViewList] = useState([]);
    const [searchText, setSearchText] = useState([]);
    const [contents,setContents] = useState([]);


    //height
    const [height, setHeight] = useState(window.innerHeight - 145);

    const OrderCheckList = async() => {
      const OrderInfo = await axiosInstance.get(`/material/materiallist`);
      setMaterialList([...OrderInfo.data]);
      setViewList([...OrderInfo.data]);

      const handleResize = () => {
        setHeight(window.innerHeight - 145);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
    useEffect(()=>{OrderCheckList();},[])

    const getData = async(_materialcode,_materialname) => {
      const materialLotList = await axiosInstance.get(`/material/materialcode?code=${_materialcode}`);
      const materiallist = materialLotList.data;
      const yearToNumber = changeDataToNumber(materiallist);
      const yearlist = getYearList(yearToNumber);
      const caculateLot = LotList(yearToNumber);
      const splitYearData = splitYearList(caculateLot,yearlist.reverse());
      setContents({name:_materialname,yearlist:yearlist.reverse(),list:splitYearData,index:0})
    }
    const LotList = (_materiallist) => {
      const materiallistLot = _materiallist.map((value) => ({...value,로트:''}));
      let LotCheck = new Map();
      let sellCount = 0;
      for(let i = 0; i < materiallistLot.length; i++){
        if(materiallistLot[i].입고 !== 0 && materiallistLot[i].연도 < 2024){
          const loadLotWeight = LotCheck.get(materiallistLot[i].규격);
          const lotNotInput = materiallistLot[i].규격 === '' ? `${materiallistLot[i].연월일} 입고` : materiallistLot[i].규격 ?? `${materiallistLot[i].연월일} 입고`;
          const checkNotInput = lotNotInput.indexOf('입고')
          if(checkNotInput !== -1){materiallistLot[i].규격 = lotNotInput;}
          if(loadLotWeight !== undefined){
            LotCheck.set(materiallistLot[i].규격,loadLotWeight+materiallistLot[i].입고)
          }else{
            LotCheck.set(materiallistLot[i].규격,materiallistLot[i].입고)
          }
        }
        if(materiallistLot[i].출고 !== 0 && materiallistLot[i].연도 < 2024){
          sellCount += materiallistLot[i].출고;
        }
      }

      //2024이전 자료 정산
      for (const [key, value] of LotCheck.entries()) {
        if (sellCount >= value) {
          // 입고량보다 더 많이 써야 함 → 전부 소진
          sellCount -= value;
          LotCheck.delete(key);
          continue; // 이 항목은 resultMap에 포함되지 않음
        }
        if(sellCount < value) {
          // 이 항목에서 다 차감되거나, 일부만 차감됨
          const leftover = Math.round((value - sellCount)*100)/100;
          // leftover가 음수면 -값으로 저장
          LotCheck.set(key, leftover);
          break; // 이후 항목은 untouched이므로 반복 중단
        }
      }
      //2024 이후 자료
      for(let i = 0; i < materiallistLot.length; i++){
        if(materiallistLot[i].입고 === 0 && materiallistLot[i].출고 === 0 && materiallistLot[i].연도 >= 2024){
          let text = '';
          for(const [key,value] of LotCheck.entries()){
            text += key+':'+value+' kg, '
          }
          materiallistLot[i].로트 = text;
        }
        if(materiallistLot[i].입고 !== 0 && materiallistLot[i].연도 >= 2024){
          const loadLotWeight = LotCheck.get(materiallistLot[i].규격);
          const lotNotInput = materiallistLot[i].규격 === '' ? `${materiallistLot[i].연월일} 입고` : materiallistLot[i].규격 ?? `${materiallistLot[i].연월일} 입고`;
          const checkNotInput = lotNotInput.indexOf('입고')
          if(checkNotInput !== -1){materiallistLot[i].규격 = lotNotInput;}
          if(loadLotWeight !== undefined){
            LotCheck.set(materiallistLot[i].규격,loadLotWeight+materiallistLot[i].입고)
          }else{
            LotCheck.set(materiallistLot[i].규격,materiallistLot[i].입고)
          }
          let text = '';
          for(const [key,value] of LotCheck.entries()){
            text += key+':'+value+' kg, '
          }
          materiallistLot[i].로트 = text;
        }
        if(materiallistLot[i].출고 !== 0 && materiallistLot[i].연도 >= 2024){
          const nullish = materiallistLot[i].규격 ?? 'nolot';
          let weight = materiallistLot[i].출고;
          //if(nullish === 'nolot'){
            let lot = '';
            for (const [key, value] of LotCheck.entries()) {
              if (weight >= value) {
                // 입고량보다 더 많이 써야 함 → 전부 소진
                weight -= value;
                lot += `[${key}:${value} kg]`;
                LotCheck.delete(key);
                continue; // 이 항목은 resultMap에 포함되지 않음
              }
              if(weight < value) {
                // 이 항목에서 다 차감되거나, 일부만 차감됨
                const leftover = Math.round((value - weight)*100)/100;
                lot += `[${key}:${weight} kg]`;
                // leftover가 음수면 -값으로 저장
                LotCheck.set(key, leftover);
                break; // 이후 항목은 untouched이므로 반복 중단
              }
            }
            let text = '';
            for(const [key,value] of LotCheck.entries()){
              text += key+':'+value+' kg, '
            }
            materiallistLot[i].로트 = text;
            materiallistLot[i].규격 = lot;
          //}else{}
        }
      }
      return materiallistLot;
    }
    const calMapData = (_mapdata,_calWeight) => {
      const keyList = [];
      const valueList = [];
      for (const [key, value] of _mapdata.entries()) {
        keyList.push(key);
        valueList.push(value);
      }
      let remain = _calWeight;
      let calLotList = [];
      let calLotWeight = [];
      for(let i = 0; i < valueList.length;){
        remain = Math.round((remain - valueList[i])*100)/100;
        if(remain < 0){
          calLotList.push(keyList[i]);
          calLotWeight.push(remain*(-1));
          return [calLotList,calLotWeight];
        }
        if(remain === 0){
          calLotList.push(keyList[i]);
          calLotWeight.push(0)
          return [calLotList,calLotWeight];
        }
        if(remain > 0){
          if(keyList.length-1 === i){
            calLotList.push(keyList[i]);
            calLotWeight.push(remain*(-1));
            return [calLotList,calLotWeight];
          }
          calLotList.push(keyList[i]);
          calLotWeight.push(valueList[i]);
          i++;
        }
      }
    }
    const splitYearList = (_materiallist,_yearlist) => {
      const splitbyYearList = [];
      let yearList = [];
      for(let i = 0,j = 0; i < _materiallist.length; i++){
        if(_materiallist[i].연도 === _yearlist[j]){
          if(i === 0){splitbyYearList.push(_materiallist[i].연도);}
          yearList.push(_materiallist[i]);
        }else{
          j++;
          splitbyYearList.push(yearList);
          yearList = [];
          splitbyYearList.push(_materiallist[i].연도);
          yearList.push({
            거래처명:"전년도 이월",
            공급가액: "0",
            규격: "",
            단가: "",
            비고:"",
            연도: _materiallist[i].연도,
            연월일: `${_materiallist[i].연도}-01-01`,
            입고: 0,
            입출고번호: "",
            출고: 0,
            코드: "",
            재고: _materiallist[i-1].재고,
            로트: _materiallist[i-1].로트
          });
          yearList.push(_materiallist[i]);
        }
        if( i ===_materiallist.length-1){splitbyYearList.push(yearList);}
      }
      return splitbyYearList;
    }
    const getYearList = (_materiallist) => {
        const yearArr = _materiallist.map((value) => value.연도);
        return yearArr.filter((value,i) => {return yearArr.indexOf(value) === i;}).reverse();
    }
    const changeDataToNumber = (_materiallist) => {
      return _materiallist.map((obj) => ({...obj,연도:Number(obj.연도),입고:Number(obj.입고),출고:Number(obj.출고)}));
    }
    const searchMaterial = (event) => {
      const text = event.target.value;
      if(text.length === 0){return setViewList([...materialList]);}
      const result = materialList.filter(listObject => listObject.materialname.toLowerCase().includes(`${text}`.toLowerCase()));
      setViewList([...result]);
    }
    const getContents = (data) => {
      setContents(data);
    }
    return (
      <div style={{display:'flex',justifyContent:'start',alignItems:'flex-start'}}>
        <div>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-around',backgroundColor:'powderblue',width:'450px'}}>
            <div>No</div>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-evenly'}}>
              품명  <TextField id="outlined-basic" label="제품 검색" variant="outlined" size='small' onChange={(e)=>searchMaterial(e)} />
            </div>
          </div>            
          <div>
            <FixedSizeList height={height} itemCount={viewList.length} itemSize={30} width="450px">
            {({ index, style }) => (
              <div style={style}>
                <Button
                  onClick={() => getData(viewList[index].materialcode, viewList[index].materialname)}
                  size='small'
                  variant="outlined"
                >
                  {index + 1}
                </Button>
                <Button 
                onClick={()=>getData(viewList[index].materialcode,viewList[index].materialname)} 
                size='small' 
                variant="outlined" 
                style={{width:'330px',justifyContent:'start',whiteSpace:'nowrap',overflow:'hidden',color:'black'}}
              >
                {viewList[index].materialname}
              </Button>
              </div>
            )}
            </FixedSizeList>          
        </div>
        </div>
      <div style={{display:'inline-block',marginLeft:'10px',width:'100%'}}>
                <LotSelectMaterial data={contents} update={getContents}></LotSelectMaterial>
      </div>
      </div>
    )
}
export default LotMaterial;